<template>
	<div>
		<vs-card>
			<b-row class="justify-content-md-start" v-if="!isMobile()">
				<b-col cols="3">
					<b-form-group label-for="item-name">
						<b-form-input v-model="searchedVal" id="smallInput" :placeholder="$t('Search')"
							@keyup.enter="filterStockList" size="sm" />
					</b-form-group>
				</b-col>
				<b-col cols="12" md="auto" style="padding-left: 0px !important;">
					<b-button class="bg-primary" style=" border-color:white;" size="sm" v-on:click="filterStockList()">
						<Icon icon="material-symbols:search-rounded" width="20" height="20" />
					</b-button></b-col>
				<b-col cols="12" md="auto" style="padding-left: 0px !important;">
					<success-btn :bgcolor="'bg-success'" :title="'AddNew'" :icon="'mingcute:add-line'" :size="'sm'" /></b-col>
			</b-row>
			<b-row class="justify-content-md-start" v-else>
				<b-col cols="6">
					<b-form-group label-for="item-name">
						<b-form-input v-model="searchedVal" id="smallInput" :placeholder="$t('Search')"
							@keyup.enter="filterStockList" size="sm" />
					</b-form-group>
				</b-col>

				<b-col cols="2" style="padding-left: 0px !important;">
					<b-button class="bg-primary" style=" border-color:white;" size="sm" v-on:click="filterStockList()">
						<Icon icon="material-symbols:search-rounded" width="20" height="20" />
					</b-button></b-col>
				<b-col cols="4" style="padding-left: 0px !important;">
					<success-btn :bgcolor="'bg-success'" :title="'AddNew'" :icon="'mingcute:add-line'" :size="'sm'" /></b-col>
			</b-row>
			<b-row>
				<ag-grid-vue ref="agGridTable" class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
					:columnDefs="stocktrackingColumns" :defaultColDef="defaultColDef" :rowData="stocktrackingList"
					rowSelection="multiple" colResizeDefault="shift" :animateRows="true" :pagination="true"
					@grid-ready="onGridReady" :suppressCopyRowsToClipboard="true"  
					:localeText="localeText">
				</ag-grid-vue>
			</b-row>

		</vs-card>



		<vs-popup :active.sync="isSidebarActiveLocal2" fullscreen>
			<StockTrackingAddNew :data="updateData" />
		</vs-popup>

		<StockTrackingDetails :isStockTrackingActive="isStockTrackingActive" :data="stockTrackingData" />
		<DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
	</div>
</template>
<script>
import SuccessBtn from '../../components/vx-button/SuccessBtn.vue'
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData"
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import updateDeleteInfoBtnCellRenderer from "../CellRenderers/updateDeleteInfoBtnCellRenderer.vue"
import StockTrackingDetails from "./StockTrackingDetails.vue";
import { isMobile } from "mobile-device-detect";
import statusShowCellRenderer from "../CellRenderers/statusShowCellRenderer.vue"
import StockTrackingAddNew from './StockTrackingAddNew.vue';
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
export default {
	data() {
		return {
			deleteData: [],
			deleteWarningPromptValid: false,
			updateData: [],
			isSidebarActiveLocal2: false,
			ROLE: this.$store.state.AppActiveUser.ROLE,
			isMobile: function () {
				return isMobile;
			},
			searchedVal: "",
			stockTrackingData: [],
			isStockTrackingActive: false,
			stocktrackingColumns: [],
			stocktrackingList: [],
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true
			},
		}
	},
	components: { DeleteWarning, StockTrackingAddNew, statusShowCellRenderer, StockTrackingDetails, updateDeleteInfoBtnCellRenderer, AgGridVue, Icon, SuccessBtn },
	computed: {
		stockTracking: {
			get() {
				return this.$store.state.stockTracking.StockTracking
			},
			set(val) {
				if (!val) {
				}
			}
		},
		localeText() {
			return i18nData[this.$i18n.locale];
		},
	},
	methods: {
		deleteStocktracking() {
			this.deleteWarningPromptValid = true;
		},
		closeDeleteWarning() {
			this.deleteWarningPromptValid = false
		},
		updateStocktracking(data) {
			this.updateData = data
			this.isSidebarActiveLocal2 = true
			//		this.$router.push({ name: 'stocktrackingaddnew', params: { data: data } })
		},
		addNewData() {
			this.isSidebarActiveLocal2 = true

			//	this.$router.push("/stock-tracking-addnew")
		},
		closePalletItemsPopup() {
			this.isStockTrackingActive = false

		},
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
			var defaultSortModel = [
				{ colId: 'CompanyName', sort: 'asc', sortIndex: 0 },
			];
			params.columnApi.applyColumnState({ state: defaultSortModel });

		},
		getStocktrackingDetailList(data) {
			this.isStockTrackingActive = true
			this.stockTrackingData = data
		},
		deleteSubmit(data) {
			const vs = this.$vs;
			console.log(data)
			this.$store
				.dispatch("stockTracking/deleteStockTracking", data.ProductTrackingId)
				.then(response => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center"
							});
							this.getStocktrackingList();
							this.deleteWarningPromptValid = false;
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data[0].value.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch(error => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});


		},

		//main stock list
		getStocktrackingList() {
			const vs = this.$vs;
			this.timelineData = [];
			this.stocktrackingColumns = []

			this.stocktrackingList = this.stockTracking
			this.stocktrackingListFiltered = this.stockTracking
			if (this.stocktrackingList.length > 0) {
				//get columns for stock list
				let columnList = Object.keys(this.stocktrackingList[0]);
				this.stocktrackingColumns.push({
					width: 150,
					pinned: "left",
					cellRendererFramework: "updateDeleteInfoBtnCellRenderer",
					cellRendererParams: {
						addMethods: "detailTrackingPopup",
						addIcon: "icon-park-solid:view-grid-detail"
					}
				},)
				columnList.forEach((val, index) => {
					if (val.toString() == "CompanyName")
						if (this.ROLE != "Company")
							this.stocktrackingColumns.push({ headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });
						else { }
					else if (val.toString() == "IsTracking")
						this.stocktrackingColumns.push({ headerName: this.$t(val), cellRendererFramework: "statusShowCellRenderer", field: val, filter: "agSetColumnFilter" });
					else if (val != "ProductTrackingId" && val != "CompanyId" && val != "ProductTrackingData" && val.toString() != "CompanyName")
						this.stocktrackingColumns.push({ headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });
				});
			}
		},
	},
	watch: {
		//if change stock traking list from store
		stockTracking(val) {
			this.getStocktrackingList();
			return val
		}
	},
	created() {
		//this.getStocktrackingList();
	},
	mounted() {
		this.$root.$on("deleteData", (data) => {
			this.deleteData = data
			this.deleteStocktracking(data);
		});
		this.$root.$on("deleteSubmit", (data) => {
			this.deleteSubmit(data);
		});
		this.$root.$on("closeDeleteWarning", () => {
			this.closeDeleteWarning();
		});
		//tables global olarak tanımlanıyor
		this.$root.$on("detailTrackingPopup", (data) => {
			this.getStocktrackingDetailList(data);
		});
		this.$root.$on("closePalletItemsPopup2", (data) => {
			this.closePalletItemsPopup(data);
		});
		this.$root.$on("addNewData", () => {
			this.addNewData();
		});
		this.$root.$on("editData", (data) => {
			this.updateStocktracking(data);
		});
	},
	beforeDestroy() {
		this.$root.$off("deleteData");
		this.$root.$off("deleteSubmit");
		this.$root.$off("detailTrackingPopup");
		this.$root.$off("closePalletItemsPopup2");
		this.$root.$off("addNewData");
		this.$root.$off("editData");
		this.$root.$off("closeDeleteWarning");
	},

}
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>